// Mirrors the existing ViewProduct cost-section branches. Raw export fields are
// kept separately; legacy truthy fallbacks here must not rewrite stored zeros.
const keys = ['costKoreanWon', 'costJPY', 'costTWD', 'costTHB', 'weight'];
const given = v => v !== undefined && v !== null && v !== '';
export const getProductPageCostSources = (product, variants, context = {}) => {
  if (product.subProducts?.length) {
    const totals = Object.fromEntries(keys.map(k => [k, 0]));
    let missing = false;
    product.subProducts.forEach((ref, i) => {
      const p = context.subProducts?.[i]?.product;
      if (!p) { missing = true; return; }
      const index = ref.style && ref.style !== '--'
        ? p.styles?.findIndex((name, n) => name === ref.style || p.styleDetails?.[n]?.style === ref.style)
        : p.styles?.length ? 0 : -1;
      const style = index >= 0 ? p.styleDetails?.[index] : null;
      const value = Object.fromEntries(keys.map(k => [k, style?.[k] || p[k] || '']));
      if (!keys.slice(0, 4).some(k => value[k]) || !value.weight) missing = true;
      for (const k of keys) if (value[k]) totals[k] += Number(value[k]) * (ref.quantity || 1);
    });
    const rawTotals = Object.fromEntries(keys.map(k => [k, totals[k] || '']));
    const value = { ...product, ...Object.fromEntries(keys.map(k => [k, given(rawTotals[k]) ? rawTotals[k] : product[k]])) };
    return [{ name: '組合合計（商品頁）', value, rawTotals, missing, styleDisplay: true,
      note: '沿用商品頁：指定款式；未指定取第一款；未匹配取子商品層級。數值 0 的沿用與四幣別加總依舊頁面；RMB 未列入頁面組合加總，原始 RMB 另行保留。空合計欄沿用母商品。' }];
  }
  const styleMode = product.styleDetails?.some(v => v && v.active !== false && keys.some(k => v[k]));
  if (!styleMode) return [{ name: '商品（商品頁）', value: product, styleDisplay: false, note: '商品頁使用商品層級成本。' }];
  return variants.filter(v => v.active !== false && v.index < (product.styles?.length || 0)).map(v => ({
    name: `${v.name}（商品頁）`, styleDisplay: true,
    value: { ...product, ...Object.fromEntries(keys.map(k => [k, v[k] || product[k]])) },
    note: '沿用商品頁款式分組：空值及數值 0 沿用商品值；字串 0 保留。款式 RMB 不參與舊頁面分組，使用商品 RMB；原始值另行保留。',
  }));
};
